import React from "react";
import ArticleImagesUploadForm from "../../components/Forms/ArticleImage/ArticleImagesUpload.Form";

const ArticleImagesUpload=  (props)=> {
    return <ArticleImagesUploadForm onUploadImage={props.onUploadImage} onCloseModel={props.onCloseModel} />
}
    export default ArticleImagesUpload;